import { render } from "./WalletCategoryAddEditForm.vue?vue&type=template&id=62a65e14&scoped=true"
import script from "./WalletCategoryAddEditForm.vue?vue&type=script&lang=js"
export * from "./WalletCategoryAddEditForm.vue?vue&type=script&lang=js"

import "./WalletCategoryAddEditForm.vue?vue&type=style&index=0&id=62a65e14&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a65e14"]])

export default __exports__